module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-06.c11a670f.png";